import { Box, Container, Grid, Typography } from "@mui/material"
import { useApiGet, useApiPost } from "auth/useApi2"
import { PageTabs } from "components/navigation/PageTabs/PageTabs"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoutes } from "generated/routes"
import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import ArticleForm from "../../components/ArticleForm/ArticleForm"
import { useTranslation } from "react-i18next"

const AddNews = () => {
  const [saveArticleResult, saveArticle] = useApiPost()
  const [customerResult, getCustomer] = useApiGet()
  const routerHistory = useHistory()
  const { t } = useTranslation("translation")

  const handleSubmit = (objectToSave) => {
    saveArticle(apiEndpoints.newsadmin.addarticle, objectToSave)
  }

  useEffect(() => {
    getCustomer(apiEndpoints.newsadmin.getcustomer)
  }, [getCustomer])

  useEffect(() => {
    if (saveArticleResult.status === 2) routerHistory.push(allRoutes.NewsAdmin())
  }, [saveArticleResult.status, routerHistory])

  const feedback = {
    errorTitle: t("news.error_article_creation", "Could not create news article")
  }

  return (
    <Box marginBottom={10}>
      <PageTabs
        routeBack
        tabs={[
          {
            path: allRoutes.NewsAdmin(),
            title: t("global.buttons.back", "Back")
          }
        ]}
      />
      <Container>
        <Grid container justifyContent="center">
          <Grid item md={12} lg={8}>
            <Box mb={5}>
              <Grid item container direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="h2">{t("news.add_news_article", "Add new article")}</Typography>
              </Grid>
            </Box>
            {customerResult.status === 2 ? (
              <ArticleForm
                customer={customerResult.data}
                onSubmit={handleSubmit}
                result={saveArticleResult}
                feedback={feedback}
              />
            ) : null}
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default AddNews
